module.exports = __webpack_public_path__ + "static/media/logo-color-icon.622e8304.svg";